import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import WordDefinitionEmbed from '../components/Exercise/WordDefinitionEmbed';

export default Node.create({
  name: 'wordDefinitionExercise',
  group: 'block',
  atom: true,
  draggable: true,
  addAttributes() {
    return {
      pairs: { 
        default: [],
        parseHTML: element => {
          const data = element.getAttribute('pairs');
          if (data) {
            try {
              return JSON.parse(data);
            } catch (e) {
              console.error('Error parsing WordDefinition pairs from HTML:', e);
              return [];
            }
          }
          return [];
        },
        renderHTML: attributes => {
          if (attributes.pairs) {
            return {
              pairs: JSON.stringify(attributes.pairs)
            };
          }
          return {};
        }
      },
      title: { 
        default: 'Word-Definition Matching',
        parseHTML: element => element.getAttribute('title') || 'Word-Definition Matching',
        renderHTML: attributes => {
          if (attributes.title) {
            return {
              title: attributes.title
            };
          }
          return {};
        }
      },
      level: {
        default: 'B1',
        parseHTML: element => element.getAttribute('level') || 'B1',
        renderHTML: attributes => {
          if (attributes.level) {
            return {
              level: attributes.level
            };
          }
          return {};
        }
      },
      exerciseId: {
        default: null,
        parseHTML: element => element.getAttribute('data-exercise-id') || null,
        renderHTML: attributes => attributes.exerciseId ? { 'data-exercise-id': attributes.exerciseId } : {}
      }
    };
  },
  parseHTML() {
    return [
      { tag: 'div[data-type="word-definition-exercise"]' },
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { 'data-type': 'word-definition-exercise' })];
  },
  addNodeView() {
    return ReactNodeViewRenderer(WordDefinitionEmbed);
  },
  addCommands() {
    return {
      insertWordDefinitionExercise:
        (attributes) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: attributes,
          });
        },
    };
  },
}); 